import { router } from "expo-router";
import { useState } from "react";
import { Text, View } from "react-native";

import { Button } from "@/components/ui/Button";
import { Input } from "@/components/ui/Input";
import { Screen } from "@/components/ui/Screen";
import { normalizeDisplayCode } from "@/lib/shows/tableDisplay";

/**
 * Where a Vendor opens a Table display on the monitor's device: type the code from Show Mode and
 * the board opens at `/t/<code>`. No sign-in, because the code is the credential. The board itself
 * takes no input; only this entry needs a keyboard, and only once.
 */
export default function TableDisplayEntryScreen() {
  const [value, setValue] = useState("");
  const [invalid, setInvalid] = useState(false);
  const open = () => {
    const code = normalizeDisplayCode(value);
    if (!code) {
      setInvalid(true);
      return;
    }
    router.push(`/t/${code}`);
  };
  return (
    <Screen className="items-center justify-center p-6">
      <View className="w-full max-w-md gap-4">
        <Text accessibilityRole="header" className="font-title text-3xl text-foreground">
          Table display
        </Text>
        <Text className="font-body text-base text-muted-foreground">
          Type the display code from Show Mode on your phone.
        </Text>
        <Input
          value={value}
          onChangeText={(text) => {
            setValue(text);
            setInvalid(false);
          }}
          onSubmitEditing={open}
          autoCapitalize="characters"
          autoCorrect={false}
          autoFocus
          accessibilityLabel="Display code"
          placeholder="K7QM-4TXP"
          error={invalid}
          className="h-14 rounded-2xl border border-border px-4 font-title text-2xl text-foreground"
        />
        {invalid
          ? (
            <Text accessibilityRole="alert" className="font-body text-sm text-loss">
              That is not a display code. It has eight letters and numbers.
            </Text>
          )
          : null}
        <Button title="Open display" onPress={open} />
      </View>
    </Screen>
  );
}
